import { Component, input, output, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-back-button',
  standalone: true,
  imports: [],
  templateUrl: './back-button.html',
  styleUrls: ['./back-button.scss']
})
export class BackButtonComponent {

  /** Ruta destino al hacer click. Obligatoria. */
  route = input.required<string>();

  /** Texto del botón. Por defecto "Regresar". */
  label = input<string>('Regresar');

  /** Emite antes de navegar, permite al padre ejecutar lógica previa. */
  beforeNavigate = output<void>();

  private router = inject(Router);

  navigate(): void {
    this.beforeNavigate.emit();
    this.router.navigate([this.route()]);
  }
}
